module.exports = __webpack_public_path__ + "img/T2C_rc_2.6597bd28.png";